import styled from 'styled-components';

export const StyledValidationMessage = styled.div`
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 18px;
	color: #f1416c;
	margin-top: 8px;
`;
